import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export type StatusTone = 'neutral' | 'accent' | 'success' | 'danger' | 'warning'

const TONES: Record<StatusTone, string> = {
  neutral: 'bg-status-neutral-bg text-status-neutral',
  accent: 'bg-status-accent-bg text-status-accent',
  success: 'bg-status-success-bg text-status-success',
  danger: 'bg-status-danger-bg text-status-danger',
  warning: 'bg-status-warning-bg text-status-warning',
}

/** The only place green, amber and red appear (ui-guidelines §2). */
export function StatusBadge({ tone, children, className }: { tone: StatusTone; children: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap', TONES[tone], className)}>
      {children}
    </span>
  )
}
